/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type reconciliation_WriteOffSubsidyRemainderRequest = {
    reasonCode: reconciliation_WriteOffSubsidyRemainderRequest.reasonCode;
};
export namespace reconciliation_WriteOffSubsidyRemainderRequest {
    export enum reasonCode {
        CITY_ROUNDING = 'city_rounding',
        KONSOLIDATION = 'konsolidation',
        INTERMEDIATE_BILLING = 'intermediate_billing',
        STORNO = 'storno',
        OTHER = 'other',
    }
}

